import { Button, Row } from "react-bootstrap";
import "./Abogado.css";

const ShowAbogado = ({ data, setVerAbogado }) => {
  const divStyles = {
    textTransform: "uppercase",
    width: 250,
    paddingRight: 20,
    fontWeight: 500,
  };


  return (
    <div className="showAbogado-container" style={{ marginTop: 50 }} >
      <div className="pt-5 pr-5 pl-5 pb-3 shadow"
        style={{
          border: "1px solid gray",
          borderRadius: "1em",
        }}
      >
        <Row className="my-1 mb-2">
          <div style={divStyles}>Apellido y Nombre</div>
          <div>{data.apellido.toUpperCase()} {data.nombre}</div>
        </Row>
        <Row className="my-1 mb-2">
          <div style={divStyles}>Documento</div>
          <div>{data.nrodni}</div>
        </Row>
        <Row className="my-1 mb-2">
          <div style={divStyles}>Dirección</div>
          <div>{data.direccion}</div>
        </Row>
        <Row className="my-1 mb-2">
          <div style={divStyles}>Telefono</div>
          <div>{data.te}</div>
        </Row>
        <Row className="my-1 mb-2">
          <div style={divStyles}>Email</div>
          <div>{data.email}</div>
        </Row>
        <Row className="my-1 mb-2">
          <div style={divStyles}>Matricula</div>
          <div>{data.matricula}</div>
        </Row>
        <Row className="my-1 mb-2">
          <div style={divStyles}>Cuit - Cuil</div>
          <div> {data.cuitcuil}</div>
        </Row>
        <Row className="my-1 mb-2">
          <div style={divStyles}>Titulo</div>
          <div>{data.abo_titulo?.titulo}</div>
        </Row>
        <Row className="my-1 mb-2">
          <div style={divStyles}>Baja</div>
          <div>{data.baja}</div>
        </Row>
        <Row className="my-1 mb-2">
          <div style={divStyles}>Codigo Externo</div>
          <div>{data.codexterno}</div>
        </Row>
        <Row className="my-1 mb-2">
          <div style={divStyles}>Horarios</div>
          <div>{data.horarios}</div>
        </Row>

        <Row className="justify-content-center pt-5">
          {setVerAbogado && <Button onClick={() => setVerAbogado({ show: false, data: null })}>Cancelar</Button>}
        </Row>
      </div>
    </div>
  );
};


export default ShowAbogado;